<template>
  <div>
    <input ref="files" @change="update" type="file" hidden />
    <el-button class="btn" size="small" @click="openFile">点击上传</el-button>
    <div v-if="icon" class="icon">
      <img :src="icon" alt="">
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" :modal="false">
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="autoCropWidth"
            :autoCropHeight="autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BigUpload from '@/js/upload'
import { VueCropper } from 'vue-cropper'
import { baseURL } from '@/utils/getawayModule'

export default {
  name: 'thumbnailUser',
  props: ['autoCropWidth', 'autoCropHeight', 'fixedNumber', 'md5s'],
  model: {
    prop: 'md5s',
    event: 'getFiles'
  },
  components: { VueCropper },
  data() {
    return {
      dialogVisible: false,
      file: '',
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 800, // 默认生成截图框宽度
        autoCropHeight: 450, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [16, 10], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true
      },
      // 防止重复提交
      loading: false,
      fileinfo: {},
      uploadFile: null,
      icon: ''
    }
  },
  watch: {
    md5s(val) {
      this.icon = val
    }
  },
  created() {
    if (this.md5s) {
      this.icon = this.md5s
    }
  },

  methods: {
    //触发单击事件
    openFile() {
      this.$refs.files.click()
    },

    update() {
      let file = this.$refs.files.files[0]
      this.option.img = URL.createObjectURL(file)
      this.dialogVisible = true
    },

    //确定
    finish() {
      this.loading = true
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], '', { type: data.type })
        let files = {
          files: []
        }
        files.files.push(file)
        this.uploadFile = new BigUpload({
          url: `${this.getaway.user}bt/files/bigupload`,
          file: files,
          size: 2097152,
          callback: (state) => {
            if (state) {
              this.fileinfo = {
                md5: state.md5,
                createDatetime: state.createDatetime,
                name: state.name
              }
              let url = `${baseURL.userApi}/file/${this.fileinfo.md5}/download`
              const protocol = window.location.protocol
              const host = window.location.host
              this.icon = protocol + '//' + host + url
              this.dialogVisible = false
              this.loading = false
              this.$emit('getFiles', this.fileinfo)
            }
          }
        })
        this.uploadFile.startUpload()
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cropper-content {
  width: 100%;
  height: 500px;
}

.cropper {
  width: 100%;
  height: 500px;
}
/deep/.icon {
  width: 180px;
  height: 180px;
  margin-top: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
